<template>
  <div>
    <textarea class="form-control" placeholder=""
              v-model="text">
    </textarea>
    <div class="d-flex justify-content-end">
      <b-button class="btn btn-success" @click="addComment" size="sm">
        {{$t('buttons.comments.add_comment')}}
      </b-button>
    </div>
    <div class="comments-wrapper">
      <div v-for="comment in comments" :key="comment.id" class="comment">
        <div class="d-flex">
          <h5>{{comment.username}}</h5>
          <div class="comment-date">{{comment.datetime}}</div>
        </div>
        <div>{{comment.text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { handlerResponse, setNotifyData } from '@/helpers/commonHelpers';

  export default {
    props: ['comments', 'url'],
    data() {
      return {
        text: ''
      }
    },
    methods: {
      addComment() {
        const requestBody = {
          text: this.text
        };
        this.$http.post(this.url, requestBody)
          .then(handlerResponse)
          .then(() => {
            this.$notify(setNotifyData('Success', 'Comment has been added!', 'success'));
            this.text = '';
            this.$emit('loadComments');
          }, () => {
            this.$notify(setNotifyData('Error', 'Unable to add a comment', 'error'));
          });
      }
    }
  }
</script>

<style scoped>
  .form-control {
    height: 100px;
    margin-bottom: 10px;
  }

  .comments-wrapper {
    margin-top: 10px;
    max-height: 200px;
    overflow-y: auto;
  }

  .comment {
    background-color: #eae4e4;
    padding: 10px 0 10px 10px;
    margin-bottom: 10px;
  }

  .comment-date {
    margin-left: 20px;
    line-height: 2.1;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Comments.vue